import React, { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import api from "@/lib/api";
import { Loader2, Wallet, TrendingUp } from "lucide-react";

export default function AdminLedger() {
  const [data, setData] = useState({ ledger: [], active_count: 0, monthly_revenue_inr: 0, plan_price_inr: 999 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/ledger");
        setData(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const daysToRenew = (iso) => {
    if (!iso) return null;
    const d = Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000);
    return d;
  };

  return (
    <DashboardShell>
      <div data-testid="admin-ledger">
        <div className="overline text-sg-gold-deep">SUBSCRIPTION LEDGER</div>
        <h1 className="font-display text-4xl text-sg-navy mt-1">Paid <span className="font-serif-italic text-sg-gold-deep">agents</span></h1>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white border border-sg-line rounded-2xl p-5" data-testid="ledger-active">
            <div className="overline text-sg-gold-deep text-[11px]">ACTIVE</div>
            <div className="mt-2 font-display text-3xl text-sg-navy">{data.active_count}</div>
            <div className="text-xs text-sg-mute">paying agents</div>
          </div>
          <div className="bg-white border border-sg-line rounded-2xl p-5" data-testid="ledger-mrr">
            <div className="overline text-sg-gold-deep text-[11px]">MONTHLY RECURRING REVENUE</div>
            <div className="mt-2 font-display text-3xl text-sg-navy">₹{Number(data.monthly_revenue_inr || 0).toLocaleString("en-IN")}</div>
            <div className="text-xs text-sg-mute">@ ₹{Number(data.plan_price_inr || 999).toLocaleString("en-IN")} / agent / month</div>
          </div>
          <div className="bg-white border border-sg-line rounded-2xl p-5" data-testid="ledger-arr">
            <div className="overline text-sg-gold-deep text-[11px]">ANNUALIZED (ARR)</div>
            <div className="mt-2 font-display text-3xl text-sg-navy">₹{(Number(data.monthly_revenue_inr || 0) * 12).toLocaleString("en-IN")}</div>
            <div className="text-xs text-sg-mute">at current paid count</div>
          </div>
        </div>

        <div className="mt-8 bg-white border border-sg-line rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-sg-cream-soft text-sg-mute text-xs uppercase">
                <tr>
                  <th className="text-left px-4 py-3">Agent</th>
                  <th className="text-left px-4 py-3">Plan</th>
                  <th className="text-left px-4 py-3">Started</th>
                  <th className="text-left px-4 py-3">Renews</th>
                  <th className="text-right px-4 py-3">Days to renewal</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={5} className="px-4 py-12 text-center text-sg-mute"><Loader2 className="w-4 h-4 animate-spin inline mr-2" />Loading…</td></tr>
                ) : data.ledger.length === 0 ? (
                  <tr><td colSpan={5} className="px-4 py-12 text-center text-sg-mute">No active subscriptions yet.</td></tr>
                ) : (
                  data.ledger.map((a) => {
                    const days = daysToRenew(a.subscription_renew_at);
                    return (
                      <tr key={a.user_id} className="border-t border-sg-line" data-testid={`ledger-row-${a.user_id}`}>
                        <td className="px-4 py-3">
                          <div className="font-medium text-sg-navy">{a.name}</div>
                          <div className="text-xs text-sg-mute font-mono">{a.email}</div>
                        </td>
                        <td className="px-4 py-3 text-xs">₹{Number(data.plan_price_inr).toLocaleString("en-IN")} / month</td>
                        <td className="px-4 py-3 text-xs font-mono">{a.subscription_started_at ? new Date(a.subscription_started_at).toLocaleDateString("en-IN") : "—"}</td>
                        <td className="px-4 py-3 text-xs font-mono">{a.subscription_renew_at ? new Date(a.subscription_renew_at).toLocaleDateString("en-IN") : "—"}</td>
                        <td className="px-4 py-3 text-right text-xs font-mono">
                          {days == null ? "—" : (
                            <span className={days <= 5 ? "text-amber-700" : "text-sg-mute"}>{days} days</span>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}
